import React from "react";
import Typography from "@material-ui/core/Typography";

export default function Title(props) {
	const { children, ...rest } = props;
	return (
		<Typography variant="h5" color="primary" gutterBottom {...rest}>
			{children}
		</Typography>
	);
}
